import styled from 'styled-components';
import { colors, fontSizes, fontWeights, lineHeights, spacings, responsiveBreakPoints } from '@styles/DesignVariables';
const { maxSmallPhone, maxSmallDesktop, maxTablet } = responsiveBreakPoints;

interface CardContainerProps {
	$borderColor?: string;
	$borderWidth?: string;
	$withShadow?: boolean;
}

interface CardTopProps {
	$linkColor?: string;
}

interface CardContentContainerProps {
	$simplifiedCard?: boolean;
}

export const CardContainer = styled.section<CardContainerProps>`
	display: flex;
	flex-direction: column;
	border-radius: 5px;
	margin-top: 45px;
	border: ${({ $borderWidth }) => ($borderWidth ? $borderWidth : '4px')} solid ${({ $borderColor }) => $borderColor};
	${(props) => props.$withShadow && 'box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);'}
	@media only screen and ${maxSmallDesktop} {
		margin-top: 23px;
	}
`;

export const CardTop = styled.div<CardTopProps>`
	display: flex;
	align-items: center;
	padding: ${spacings.s16} ${spacings.s24} ${spacings.s16} ${spacings.s16};
	position: relative;
	border-bottom: 1px solid #e9e9e9;
	@media only screen and ${maxSmallDesktop} {
		flex-direction: column;
		align-items: flex-start;
		padding: ${spacings.s8} ${spacings.s16} ${spacings.s8} ${spacings.s16};
	}
	p {
		@media only screen and ${maxSmallDesktop} {
			margin-top: 4px;
		}
	}
	a {
		color: ${({ $linkColor }) => $linkColor};
		text-decoration: underline !important;
		&:hover {
			color: ${({ $linkColor }) => $linkColor};
		}
		@media only screen and ${maxSmallDesktop} {
			font-size: 14px;
			line-height: 130%;
		}
	}

	svg {
		position: absolute;
		top: -29px;
		right: 16px;
		height: auto;
		@media only screen and ${maxSmallDesktop} {
			max-width: 82px;
			right: 8px;
			top: -22px;
		}
		@media only screen and ${maxSmallPhone} {
			max-width: 82px;
			max-height: 72px;
			top: -18px;
		}
	}
`;

export const ProductName = styled.h4`
	color: ${colors.greyTitle};
	font-size: ${fontSizes.cardHeading};
	font-weight: ${fontWeights.bold};
	line-height: ${lineHeights.cardHeading};
	@media only screen and ${maxSmallDesktop} {
		font-size: ${fontSizes.cardHeadingMobile};
		line-height: 100%;
	}
`;

export const BrandName = styled.h4`
	color: ${colors.greyTitle};
	font-size: ${fontSizes.cardHeading};
	font-weight: ${fontWeights.bold};
	line-height: ${lineHeights.cardHeading};
	@media only screen and ${maxSmallDesktop} {
		font-size: 14px;
		line-height: normal;
	}
`;

export const CardContent = styled.div`
	display: grid;
	grid-template-columns: repeat(4, auto);
	padding: ${spacings.s24} ${spacings.s16};
	@media only screen and ${maxSmallDesktop} {
		padding: ${spacings.s16} ${spacings.s16} ${spacings.s24} ${spacings.s16};
		grid-template-columns: unset;
	}
`;

export const SimplifiedCardTitle = styled.h4`
	font-size: 24px;
	color: #333;
	line-height: 130%;
	font-weight: 700;
	font-family: 'Roboto', sans-serif;
`;

export const SimplifiedCardContent = styled.div`
	display: grid;
	grid-template-columns: 240px auto 240px;
	padding: ${spacings.s32} ${spacings.s24};
	@media screen and (${maxSmallDesktop}) {
		padding: ${spacings.s16} ${spacings.s16} ${spacings.s24} ${spacings.s16};
		grid-template-columns: unset;
	}
`;

export const CardContentContainer = styled.div<CardContentContainerProps>`
	display: ${({ $simplifiedCard }) => ($simplifiedCard ? 'flex' : 'initial')};
	flex-direction: ${({ $simplifiedCard }) => ($simplifiedCard ? 'column' : 'initial')};
	justify-content: ${({ $simplifiedCard }) => ($simplifiedCard ? 'center' : 'initial')};
	border-right: 1px solid #f2f2f2;
	padding: 0 16px;
	height: 100%;
	width: ${({ $simplifiedCard }) => ($simplifiedCard ? 'initial' : 'fit-content')};

	&:last-child {
		border: none;
	}

	&:first-of-type {
		padding-left: 0;
	}

	&:last-of-type {
		padding-right: 0;
	}
`;

export const CardContentContainerMobile = styled.div<CardContentContainerProps>`
	display: flex;
	justify-content: space-evenly;
	align-items: center;
`;

export const SimplifiedCardParagraph = styled.section`
	font-size: 14px;
	font-family: 'Roboto', sans-serif;
	color: #636363;
	line-height: 150%;
	font-weight: 400;
	text-align: left;
	@media screen and (${maxTablet}) {
		text-align: center;
	}
`;

export const CardTextContainer = styled.div<CardContentContainerProps>`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	border-right: 1px solid #f2f2f2;
	padding: 0 16px;
	height: 100%;
	gap: 24px;
	@media screen and (${maxSmallDesktop}) {
		border-right: none;
		gap: 16px;
		text-align: center;
		margin: 16px 0px;
		padding: 0px;
	}
`;

export const MobileLink = styled.a`
	font-family: 'Roboto', sans-serif;
	font-weight: 700;
	font-size: 16px;
	line-height: 24px;
	letter-spacing: 0%;
	text-decoration: underline;
	color: #0060c3;
	margin-top: 15px;
	text-align: center;
`;
